import React, { useState } from 'react';
import './App.css';

// IMAGE PATHS
const images = {
  hero: "images/hero-bg.jpg", 
  logo: "images/sunita-logo.png",
  services: {
    threading: "images/threading-eye.jpg",
    lashes: "images/lashes.jpg",
    waxing: "images/waxing.jpg",
    facial: "images/facial.jpg"
  },
  gallery: {
    main: "images/salon-main.jpg",
    reception: "images/salon-reception.jpg",
    room: "images/treatment-room.jpg"
  }
};

function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const toggleModal = () => setIsModalOpen(!isModalOpen);

  // Smooth scroll handler
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <div className="App">
      {/* --- NAVIGATION --- */}
      <header className="navbar">
        <div className="logo-container">
          <img src={images.logo} alt="Sunita Brow Bar" style={{height: '50px'}} />
        </div>
        <nav className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
          <button onClick={() => scrollToSection('about')}>About</button>
          <button onClick={() => scrollToSection('services')}>Services</button>
          <button onClick={() => scrollToSection('gallery')}>Gallery</button>
          <button onClick={() => scrollToSection('contact')}>Contact</button>
          <button className="btn-book-nav" onClick={toggleModal}>Book Now</button>
        </nav>
        <div className="hamburger" onClick={toggleMenu}>☰</div>
      </header>

      {/* --- HERO SECTION --- */}
      <section className="hero" style={{ backgroundImage: `linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url(${images.hero})` }}>
        <div className="hero-content">
          <h1>Sunita Brow Bar</h1>
          <p>Experience expert brow artistry and luxury beauty services in Cardiff.</p>
          <div className="hero-buttons">
            <button className="btn-primary" onClick={toggleModal}>Book Appointment</button>
            <button className="btn-outline" onClick={() => scrollToSection('services')}>View Services</button>
          </div>
        </div>
      </section>

      {/* --- ABOUT / INTRO --- */}
      <section id="about" className="section bg-light text-center">
        <div className="container">
           <h2 className="section-title">Crafting Beauty with Passion</h2>
           <p style={{maxWidth: '700px', margin: '0 auto', lineHeight: '1.8'}}>
             Welcome to Sunita Brow Bar. Specializing in the ancient art of threading and modern beauty techniques, our studio offers a range of services designed to enhance your natural features. From precision brows to bespoke facials, our experienced team delivers exceptional results in a professional environment.
           </p>
        </div>
      </section>

      {/* --- SERVICES SECTION --- */}
      <section id="services" className="section">
        <div className="container">
          <h2 className="section-title">Our Services</h2>
          <p className="section-subtitle">Comprehensive beauty solutions tailored just for you.</p>
          
          <div className="grid-container">
            {/* Threading */}
            <div className="card">
              <img src={images.services.threading} alt="Threading" />
              <div className="card-body">
                <h3>Threading & Tinting</h3>
                <h4 className="service-category">Threading</h4>
                <ul className="price-list">
                  <li><span>Eyebrows</span> <strong>£6.00</strong></li>
                  <li><span>Upper Lip</span> <strong>£5.00</strong></li>
                  <li><span>Full Face</span> <strong>£30.00</strong></li>
                </ul>
                <h4 className="service-category">Tinting</h4>
                <ul className="price-list">
                  <li><span>Eyebrows</span> <strong>£10.00</strong></li>
                  <li><span>Eyebrows & Eyelash</span> <strong>£20.00</strong></li>
                </ul>
              </div>
            </div>

            {/* Lashes */}
            <div className="card">
              <img src={images.services.lashes} alt="Lashes" />
              <div className="card-body">
                <h3>Eyelash Extensions</h3>
                <ul className="price-list">
                  <li><span>Eyelash Cluster</span> <strong>£30.00</strong></li>
                  <li><span>Classic Full Set</span> <strong>£55.00</strong></li>
                </ul>
              </div>
            </div>

            {/* Waxing */}
            <div className="card">
              <img src={images.services.waxing} alt="Waxing" />
              <div className="card-body">
                <h3>Waxing Services</h3>
                <ul className="price-list">
                  <li><span>Eyebrows</span> <strong>£8.00</strong></li>
                  <li><span>Under Arms</span> <strong>£10.00</strong></li>
                  <li><span>Full Legs</span> <strong>£30.00</strong></li>
                  <li><span>Full Body</span> <strong>£110.00</strong></li>
                </ul>
              </div>
            </div>

            {/* Facial */}
            <div className="card">
              <img src={images.services.facial} alt="Facial" />
              <div className="card-body">
                <h3>Facial & Massage</h3>
                <h4 className="service-category">Facials</h4>
                <ul className="price-list">
                  <li><span>Diamond Facial</span> <strong>£45.00</strong></li>
                  <li><span>Deep Cleaning</span> <strong>£35.00</strong></li>
                </ul>
                <h4 className="service-category">Massage</h4>
                <ul className="price-list">
                  <li><span>Head Massage</span> <strong>£30.00</strong></li>
                  <li><span>Full Body Massage</span> <strong>£60.00</strong></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* --- GALLERY SECTION --- */}
      <section id="gallery" className="section bg-light">
        <div className="container">
          <h2 className="section-title">Our Gallery</h2>
          <p className="section-subtitle">A glimpse into our luxurious styling suite and relaxing treatment rooms.</p>
          <div className="gallery-grid">
            <div className="gallery-item">
              <img src={images.gallery.main} alt="Main Salon" />
              <div className="overlay"><h3>The Styling Suite</h3></div>
            </div>
            <div className="gallery-item">
              <img src={images.gallery.reception} alt="Reception" />
              <div className="overlay"><h3>Warm Welcome</h3></div>
            </div>
            <div className="gallery-item">
              <img src={images.gallery.room} alt="Treatment Room" />
              <div className="overlay"><h3>Private Spa Room</h3></div>
            </div>
          </div>
        </div>
      </section>

      {/* --- CONTACT SECTION --- */}
      <section id="contact" className="contact-section">
        <div className="contact-form">
          <h2>Get in Touch</h2>
          <p style={{marginBottom:'20px'}}>Ready to transform your look? Send us a message.</p>
          <form onSubmit={(e) => { e.preventDefault(); alert("Message Sent!"); }}>
            <div className="form-row">
                <input type="text" placeholder="First Name" required />
                <input type="text" placeholder="Last Name" required />
            </div>
            <div className="form-row">
                <input type="email" placeholder="Email Address" required />
                <input type="tel" placeholder="Phone Number" required />
            </div>
            <textarea placeholder="Your Message" rows="4"></textarea>
            <button type="submit" className="btn-primary full-width">Send Message</button>
          </form>
        </div>
        <div className="contact-info">
          <div className="info-item">
             <h3>Visit Us</h3>
             <p>330 Cowbridge Rd E<br/>Cardiff CF5 1HD</p>
          </div>
          <div className="info-item">
             <h3>Call Us</h3>
             <p>07405 613817</p>
          </div>
          <div className="info-item">
             <h3>Opening Hours</h3>
             <p>Mon - Sat: 9:00 AM - 6:00 PM<br/>Sunday: 11:00 AM - 5:00 PM</p>
          </div>
          <div className="info-item">
             <h3>Email Us</h3>
             <p>nath.sunita1981@gmail.com</p>
          </div>
        </div>
      </section>

      {/* --- FOOTER --- */}
      <footer>
        <div className="footer-content">
            <p>&copy; 2025 Sunita Brow Bar. All rights reserved.</p>
        </div>
      </footer>

      {/* --- BOOKING MODAL (SIMPLE IFRAME VERSION) --- */}
      {isModalOpen && (
        <div className="modal-overlay" onClick={toggleModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{maxWidth: '800px', padding: '0', height: '750px', overflow: 'hidden'}}>
            <span className="close-btn" onClick={toggleModal} style={{zIndex: '1000', color: 'black', right:'15px', top:'10px', fontSize:'2rem'}}>&times;</span>
            
            {/* Direct Iframe - 100% Reliable */}
            <iframe 
              src="https://calendly.com/nath-sunita1981" 
              width="100%" 
              height="100%" 
              frameBorder="0"
              title="Book Appointment"
            ></iframe>
            
          </div>
        </div>
      )}
    </div>
  );
}

export default App;